import cn from "classnames";

export default function Input({ label, error, className, unit, ...props }) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="text-xs font-medium text-gray-600 uppercase tracking-wide">
          {label}
        </label>
      )}
      <div className="relative flex items-center">
        <input
          {...props}
          className={cn(
            "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm placeholder-gray-400 transition focus:border-bh-500 focus:outline-none focus:ring-1 focus:ring-bh-500",
            error && "border-red-400 focus:border-red-400 focus:ring-red-400",
            unit && "pr-12",
            className
          )}
        />
        {unit && (
          <span className="absolute right-3 text-xs text-gray-400 pointer-events-none">
            {unit}
          </span>
        )}
      </div>
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}
